import { render, staticRenderFns } from "./m-new-goal-pop.vue?vue&type=template&id=3f937c4d&"
import script from "./m-new-goal-pop.vue?vue&type=script&setup=true&lang=js&"
export * from "./m-new-goal-pop.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports